import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-fit" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "flex center align-c wrap w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialMediaIcons = _resolveComponent("SocialMediaIcons")!
  const _component_MobileHomeLinks = _resolveComponent("MobileHomeLinks")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex column align-c", _ctx.$style.homePageContainer])
  }, [
    (!_ctx.isMobileView)
      ? (_openBlock(), _createBlock(_component_SocialMediaIcons, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: _normalizeClass(["light-text", _ctx.$style.introAndPortrait])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.aboutMe)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex column", _ctx.$style.bioNameContainer])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.nameHeader)
          }, "Hi, I'm Stephen. ", 2),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", {
              class: _normalizeClass(["responsive-text-large", _ctx.$style.bio])
            }, [
              _createTextVNode(" Driven by a "),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.bioHighlight)
              }, "passion for learning", 2),
              _createTextVNode(", I thrive on mastering new technologies, unraveling complex problems, and continuously expanding my skill set. "),
              _hoisted_2,
              _hoisted_3,
              _createTextVNode(" In every project, I bring not just technical expertise but a mindset fueled by the "),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.$style.bioHighlight)
              }, "excitement", 2),
              _createTextVNode(" of exploration and discovery. ")
            ], 2)
          ]),
          (!_ctx.isMobileView)
            ? (_openBlock(), _createBlock(_component_MobileHomeLinks, { key: 0 }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          id: "sbPortrait",
          class: _normalizeClass(_ctx.$style.sbImage)
        }, null, 2)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isMobileView)
        ? (_openBlock(), _createBlock(_component_MobileHomeLinks, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}